import { PropsWithChildren } from "react";

interface IConditionProps extends PropsWithChildren {
  if: boolean;
}

function Condition({ if: condition, children }: IConditionProps) {
  if (condition) {
    return <>{children}</>;
  }

  return null;
}

const View = { Condition };

export { View };
